import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import type OutgoingPayGateReversalPayment from "entities/outgoingPayGateReversalPayment";
import type { ListColumnDefinition } from "views/common/list";
import ListView from "views/common/list";
import React from "react";
import { formatAmount, formatDateTime } from "utils/localizations";
import PaygateReversalViewModel from "viewModels/finance/outgoingPayments/paygateReversalViewModel";
import PayGateReversalPaymentFilters from "./payGateReversalPaymentsFilters";
import { emptyValue } from "utils/emptyValue";

const PaygateReversalView: ViewComponent<PaygateReversalViewModel> = observer(({ vm }) => {
  const columns: ListColumnDefinition<OutgoingPayGateReversalPayment>[] = [
    {
      property: "authorizedAt",
      title: vm.translateAttribute("authorizedAt"),
      valueFormatter: props => formatDateTime(props.value),
    },
    {
      property: "variableSymbol",
      title: vm.translate("variableSymbolOutgoingPayment"),
      valueFormatter: props => props.value || emptyValue,
    },
    {
      property: "paidAmount",
      title: vm.translateAttribute("paidAmount"),
      valueFormatter: props => formatAmount(props.value),
    },
    {
      property: "cardNumber",
      title: vm.translateAttribute("cardNumber"),
      valueFormatter: props => props.value ?? emptyValue,
      numberProperty: true,
    },
    {
      property: "arn",
      title: vm.translateAttribute("arn"),
      valueFormatter: props => props.value ?? emptyValue,
      numberProperty: true,
    },
  ];

  return (
    <>
      <PayGateReversalPaymentFilters vm={vm} />
      <ListView showDetailWithList={true} mandatoryFilter={true} vm={vm} columns={columns} hideTitle={true} />
    </>
  );
});

registerView(PaygateReversalView, PaygateReversalViewModel);
